/**
 * HUMANSTARSapp
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SettingsTheme = {
    Auto: 'auto',
    Light: 'light',
    Dark: 'dark'
} as const;
export type SettingsTheme = typeof SettingsTheme[keyof typeof SettingsTheme];

